import React, {Component} from 'react'
import styled, { ThemeConsumer } from 'styled-components'
import fire from '../database/firebase'
import {Nav, Navbar, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'
import shortid from 'shortid'
import ShowMoreText from "react-show-more-text";
import useWindowSize from 'react-use/lib/useWindowSize'
import Confetti from 'react-confetti'
import DailyReport from '../dailyreport/DailyReport'
import { ReactDialogBox } from 'react-js-dialog-box'
import 'react-js-dialog-box/dist/index.css'
import copy from 'copy-to-clipboard';
import TaskTrail from '../task-trail/TaskTrail'

const Styles = styled.div `


    // - - NAVBAR - - //

.theNavbar {
    max-width: 95%;
}

.logo {
    font-family: Val;
    color: #99CC63;
    font-size: 30px;
    margin-left: 2%;
    cursor: pointer;
}

.logo:hover {
    color: #724E39;
}

.linkItem {
    max-width: 100%;
    margin-right: 15%;
    }

    // - - NAVBAR LINKS - - //

.navLinks {
    margin-right: 15%;
    color: #FF3C33;
    font-size: 20px;
    font-family: DM Sans;
}

.linkItem {
    margin-right: 50%;
}

.linkItem label {
    color: #99CC63;
    cursor: pointer;
}

.linkItem label:hover {
    color: #724E39;
}

    // - - GET STARTED PG - - //

.getStartedPg {
    text-align: center;
    margin-top: 3%;
}

.getStartedPg button {
    padding: 1%;
    background-color: #99CC63;
    color: #724E39;
    font-family: DM Sans;
    outline: none;
    font-size: 18px;
    border: 2px solid #99CC63;
    border-radius: 8px;
    font-weight: bold;
    margin-top: 1%;
    padding-left: 3%;
    padding-right: 3%;
}

    // - - HEADER - - //

.header {
    text-align: center;
}

.header h1 {
    font-family: DM Sans;
    color: #724E39;
}

    // - - MAIN PAGE DIMENSIONS - - //

.mainPg {
//     content: "";
//     display:table;
//     clear: both;
}

// .mainPgCol1 {
//     width: 20%;
//     text-align: center;
//     float: left;
// }

.mainPgCol1 h4 {
    font-family: Libre Franklin Black;
    display-inline: block;
    font-size: 21px;
    margin-left: 4%;
    margin-right: 4%;
}

// .mainPgCol2 {
//     width: 80%;
//     text-align: center;
//     float: left;
// }

    // - - THE LIST - - //

.theList {
    text-align: center;
    margin-bottom: 3%;
}

.theList button {
    padding: 1.5%;
    background-color: #99CC63;
    color: #724E39;
    font-family: DM Sans;
    outline: none;
    border: 2px solid #99CC63;
    border-radius: 8px;
    font-weight: bold;
    margin-top: 1%;
}

.theList h3 {
    text-align: justify;
    margin-left: 15%;
    margin-top: 1%;
    font-family: DM Sans;
}

.homeTopButtons:after {
    content: "";
    display:table;
    clear: both;
}

.homeTopBtn {
    width: 50%;
    text-align: center;
    float: left;
}

    // - - TASK TRAIL BUTTONS - - //

.taskTrailBtn {
    
}

.taskTrailBtn button {
    width: 20%;
    padding: 1%;
    background-color: white;
}

.taskTrailBtn button:hover {
    background-color: #99CC63;
    color: white;
}

    // - - ITEM ADD CONTIANER - - //

.itemAddContainer {
    text-align: center;
}

.itemAddContainer h4 {
    margin-top: 4%;
    font-family: DM Sans;
}

.itemAddContainer p {
    font-family: DM Sans;
    font-weight: bold;
    color: red;
}

.addContainer {
    text-align: center;
    border: 0px solid black;
    border-radius: 8px;
    margin-bottom: 2%;
    margin-top: 2%;
    margin-left: 15%;
    margin-right: 15%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.addContainer:after {
    content: "";
    display:table;
    clear: both;
}

.addLabel {
    width: 20%;
    text-align: center;
    float: left;
    height: 60px;
}

.addLabel h5 {
    line-height: 60px;
}

.addInput {
    width: 80%;
    text-align: center;
    float: left;
    height: 60px;
    border-left: 1px solid black;
}

        // - - DIFFICULTY BUTTON - - //

.difficultyBtn {
    width: 20%;
    text-align: center;
    float: left;
}

.difficultyBtnLast {
    width: 20%;
    text-align: center;
    float: left;
}

.difficultyBtnFirst {
    width: 20%;
    text-align: center;
    float: left;
}

        // - - CATEGORY BUTTON - - //

.categoryBtn {
    width: 20%;
    text-align: center;
    float: left;
}

.categoryBtnFirst {
    width: 20%;
    text-align: center;
    float: left;
}

.categoryBtnLast {
    width: 20%;
    text-align: center;
    float: left;
}

        // - - PRIORITY BUTTON - - //

.priorityBtnFirst {
    width: 50%;
    text-align: center;
    float: left;
}

.priorityBtnLast {
    width: 50%;
    text-align: center;
    float: left;
}

.addInput:after {
    content: "";
    display:table;
    clear: both;
}

.addInput input {
    width: 100%;
    height: 60px;
    border: 0px solid transparent;
    padding: 7px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    outline-color: #99CC63;
    margin-bottom: 0px;
}

        // - - DIFFICULTY BUTTONS - - //

.difficultyBtn button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-left: 1px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

.difficultyBtnFirst button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-left: 0px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

.difficultyBtnLast button {
    width: 100%;
    height: 60px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border: 2px solid transparent;
    border-left: 1px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

        // - - CATEGORY BUTTONS - - //

.categoryBtn button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-left: 1px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

.categoryBtnFirst button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-left: 0px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

.categoryBtnLast button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-left: 1px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

        // - - PRIORITY BUTTONS - - //

.priorityBtnFirst button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-left: 0px solid black;
    font-weight: bold;
    font-family: DM Sans;
}

.priorityBtnLast button {
    width: 100%;
    height: 60px;
    border: 2px solid transparent;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-left: 1px solid black;
    font-weight: bold;
    font-family: DM Sans;   
}

    // - - LAST ADD BUTTON - - //

.lastAddBtn button {
    background-color: #99CC63;
    color: #724E39 ;
    padding: 1%;
    border: 2px solid  #99CC63;
    border-radius: 8px;
    font-family: DM Sans;
    font-weight: bold;
    width: 150px;
    margin-top: 1%;
    margin-bottom: 1%;
}

    // - - ADDED ITEM SUCCESSFULLY - - //

.successfulAdd {
    text-align: center;
    margin-top: 10%;
}

.successfulAdd h2 {
    font-family: DM Sans;
    color:  #99CC63;
}

.successfulAdd button {
    background-color: #99CC63;
    color:  #724E39;
    padding: 1%;
    border: 2px solid  #99CC63;
    border-radius: 8px;
    font-family: DM Sans;
    font-weight: bold;
    width: 200px;
    margin-bottom: 2%;
}

    // - - ALL TASKS - - //

.allTasks {
    text-align: center;
    border: 0px solid black;
    border-radius: 8px;
    margin-bottom: %;
    margin-top: 2%;
    margin-left: 7%;
    margin-right: 7%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskInfo:after {
    content: "";
    display:table;
    clear: both;
}

.taskInfo {
    text-align: left;
}


.taskLabel {
    width: 20%;
    text-align: center;
    float: left;
    margin-top: 1.25%;
}

.taskLabel img {
    display: inline-block;
    width: 10%;
    margin-right: 2%;
    // margin-top: 1%;
    // margin-left: 6%;
    // margin-bottom: 0px;
}

.taskData {
    width: 50%;
    text-align: center;
    float: left;
    margin-top: 1%;
}

.taskDataChild {
    margin-right: 5%;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskDataChild2 {
    margin-right: 5%;
}

.taskDataChild2 p {
    font-size: 15px !important;
    margin-bottom: 0px !important;
}

.taskDifficulty {
    width: 30%;
    text-align: center;
    float: left;
    margin-top: 1%;
}

.taskLabel h5 {
    font-family: DM Sans;
    font-size: 18.5px;
    display: inline-block;
}

.taskData p {
    text-align: left;
    font-family: Poppins;
    font-size: 17.5px;
    margin-right: 5%;
    margin-bottom: 0.5%;
    padding: 0.5%;
    margin-left: 1%;
}

.taskData textarea {
    width: 100%;
    padding: 5px;
    font-family: DM Sans;
    margin-right: 5%;
    border-radius: 8px;
    height: 95px;
    resize: none;
    border: 2px solid transparent;
    outline: none;
    // overflow-y: scroll;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskDifficulty label {
    text-align: justify;
    float: left;
    font-family: DM Sans;
}

.taskCategory {
    text-align: center;
}

.taskCategory p {
    float: left;
    font-size: 18.5px;
    font-family: DM Sans;
    font-weight: bold;
}


.taskCategory label {
    text-align: center;
}

.markComplete h4 {
    color: transparent;
}

    // - - TASK BUTTON ACTIONS - - //

.taskBtnAction {
    text-align: left;
    margin-left: 6%;
}

.taskBtnAction2 {
    text-align: center;
    // margin-left: 7%;
}

.taskBtnAction p {
    margin-top: 1%;
}

.taskBtnAction button {
    border: 2px solid transparent;
    padding: 1%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.taskBtnAction2 button {
    border: 2px solid transparent;
    padding: 1%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    width: 150px;
}

.noteCopyBtn button {
    width: 200px;
    background-color: #F6E394;

}

.taskBtnAction2 p {
    margin-top: 2.5%;
    margin-bottom: 1%;
    font-family: DM Sans;
    color: white;
    font-weight: bold;
    font-size: 18px;
}

.taskBtnAction2 textarea {
    resize: none;
    lines: 4;
    width: 60%;
    padding: 5px;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border: 2px solid transparent;
    outline: none;
    text-align: left;
    font-family: DM Sans;
    font-size: 17.5px;
}

    // - - EXAMPLE LIST - - //

.exampleList h4 {
    font-family: DM Sans;
    color: white;
}

.exampleList p {
    font-family: DM Sans;
    color: white;
    font-weight: bold;
}

    // - - HIDE ITEMS - - //

.hideItems {
    text-align: right;
}

.hideItems button {
    height: 0px;
    padding: 0%;
    margin-right: 3%;
    font-size: 15px;
    color: white;
    background-color: transparent;
    border: 2px solid transparent;
    padding-bottom: 0px;
    padding-top: 0px;
}

.modalDialogBox {
    border-radius: 10px;
    // height: 100vh;
    overflow-y: scroll;
}

.maximizeDialogBox {
    height: 100%;
}

.maximizeDialogBox video {
    width: 80%;
}

.maximizeDialogBox h4 {
    font-family: DM Sans;
    color: #724E39;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0%;
}

.maximizeDialogBox p {
    margin-top: 1%;
    color: #724E39;
    font-family: DM Sans;
}

.newTaskDialogBox {
    height: 80vh;
    overflow-y: scroll;
}

.newTaskDialogBox video {
    width: 60%;
    margin-top: 0%;
    margin-bottom: 0px;
}

.newTaskDialogBox button {
    margin-bottom: 0px;
    padding: 0.75%;
    background-color: #99CC63;
    color: #724E39;
    font-family: DM Sans;
    outline: none;
    border: 2px solid #99CC63;
    border-radius: 8px;
    font-weight: bold;

}

.newTaskDialogBox h4 {
    font-family: DM Sans;
    color: #724E39;
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 0%;
}

.newTaskDialogBox p {
    color: #724E39;
    margin-bottom: 0px;
}

.dialogueBox h4 {
    font-family: DM Sans;
    color: #724E39;
    font-weight: bold;
    margin-top: 1%;
}


.dialogueBox img {
    width: 50%;
    margin-top: 4%;
}

.dialogueBox {
    text-align: center;
}

    // - - SLOW MODE BUTTON - - //

.slowMode {
    text-align: center;
}

.slowModeBtn button {
    font-family: DM Sans;
    padding: 1% !important;
    padding-left: 2% !important;
    padding-right: 2% !important;
    margin-top: 2% !important;
    margin-bottom: 1.5% !important;
    margin-left: 0px !important;
    background-color: #F5DE89 !important;
    color: #724E39 !important; 
    border: 2px solid #F5DE89 !important;
    border-radius: 8px;
    font-weight bold;
}

.slowModeBtn h4 {
    font-family: DM Sans;
    font-weight: bold;
    color: #724E39;
    font-size: 18px;
}

// - - - - - - - - - - - PHONE DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 650px) {

        // - - NAVBAR LINKS - - //

    .linkItem label {
        margin-left: 5%;
    }

        // - - GET STARTED - - //


    .getStartedPg button {
        padding: 3%;
    }


        // - - THE LIST - - //

    .theList button {
        padding: 5%;
        margin-bottom: 10%;
        font-size: 12px;
    }

    .theList h3 {
        text-align: justify;
        margin-left: 5%;
        margin-top: 1%;
        font-family: DM Sans;
    }


        // - - TASK TRAIL BUTTONS - - //

    .taskTrailBtn {
        
    }
    
    .taskTrailBtn button {
        width: 60%;
        padding: 3%;
        margin-bottom: 4%;
        font-size: 15px;
    }

        // - - DIFFICULTY BUTTONS - - //

    .difficultyBtn button {
        // font-size: 6px;
    }
    
    .difficultyBtnFirst button {
        // font-size: 6px;
    }
    
    .difficultyBtnLast button {
        // font-size: 6px;
    }




        // - - ALL TASKS - - //

    .allTasks {
        margin-bottom: 5%;
        margin-top: 1%;
        margin-left: 5%;
        margin-right: 5%;
    }

    .taskLabel {
        width: 100%;
        margin-left: 3%;
    }

    .taskData {
        width: 100%;
        font-weight: bold;
        margin-left: 3%;
    }

    .taskDifficulty {
        width: 100%;
        margin-left: 3%;
    }

    .taskDifficulty button {
        font-size: 14.5px;
    }

    .taskLabel h5 {
        display: inline-block;
        margin-top: 3.5%;
        font-size: 16.75px;
        text-align: left;
        margin-bottom: 1%;
        margin-left: 2%;
    }

    .taskData p {
        font-family: DM Sans;
        padding-top: 1%;
        padding-bottom: 1%;
        font-size: 14.5px;
        margin-bottom: 1%;
        margin-left: 1.5%;
    }

        // - - TASK BUTTON ACTIONS - - //

    .taskBtnAction {
        text-align: left;
        margin-left: 3%;
        margin-top: 3%;
    }

    .taskBtnAction button {
        margin-bottom: 5px;
    }

        // - - MARK COMPLETE - - //

    .markComplete button {
        padding: 3%;
    }

        // - - ADD CONTAINER - - //

    .addContainer {
        margin-left: 5%;
        margin-right: 5%;
    }

        // - - ADD LABEL - - //

    .addLabel h5 {
        font-size: 10px;
    }

        // - - ADD INPUT - - //

    .addInput input {
        outline: none;
    }

        // - - ADD BUTTONS - - //

    .addContainer button {
        font-size: 9px;
    }

        // - - LAST ADD BUTTON - - //

    .lastAddBtn button {
        padding: 3%;
    }

        // - - SUCCESSFULL ADD BUTTON - - //

    .successfulAdd button {
        padding: 3%;
    }

        // - - TEXTAREA ADDING NOTES - - //

    .taskBtnAction2 button {
        margin-bottom: 5px;
    }

    .taskBtnAction2 textarea {
        width: 95%;
        font-size: 14.5px;
    }

        // - - HIDE ITEMS BUTTON - - //

    .hideItems button {
        font-size: 15px;
        padding-bottom: 5%;
        margin-bottom: 0px;
    }

        // - - DEMOS - - //

    .newTaskDialogBox {
        height: 100%;
        overflow-y: scroll;
    }

    .newTaskDialogBox video {
        width: 100%;
        margin-top: 0%;
        margin-bottom: 0px;
    }

    .newTaskDialogBox h4 {
        font-family: DM Sans;
        color: #724E39;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 0%;
        margin-left: 2%;
        margin-right: 2%;
    }
    
    .newTaskDialogBox p {
        color: #724E39;
        font-size: 12px;
        margin-bottom: 0px;
        margin-left: 2%;
        margin-right: 2%;
        text-align: justify;
    }

    .newTaskDialogBox button {
        padding: 2.5%;
    
    }

    .dialogueBox img {
        width: 100%;
        margin-top: 4%;
    }
    
    .dialogueBox h4 {
        font-size: 14px;
        font-family: DM Sans;
        color: #724E39;
        font-weight: bold;
        margin-top: 1%;
        margin-left: 2%;
        margin-right: 2%;
    }

    .maximizeDialogBox h4 {
        font-size: 16px;
    }
    
    .maximizeDialogBox video {
        width: 100%;
    }

        // - - SLOW MODE - - //

    .slowModeBtn button {
        padding: 3% !important;
        padding-left: 4%;
        padding-right: 4%;
        font-size: 15px;
    }

    .slowModeBtn h4 {
        margin-top: 2%;
        margin-bottom: 4%;
    }

}



`

export default class Home extends Component {
    constructor() {
        super()
        this.state = {
            // EMAIL
            userEmail: "",

            // HOME

            homeTxt: "Home",

            // TASKS
            lowPriorityTasks: [],
            highPriorityTasks: [],
            taskExamples: [],
            taskComplete: "",
            taskCompleteBtn: "Task Completed",
            taskSuccess: "",
            exampleTxt: "",
            exampleErrMsg: "Enter an example",
            userExampleInput: "",
            minimizeTxt: "Minimize",
            greyTxt: "Grey",
            saveTaskTxt: "",
            saveNoteTxt: "",
            noteCopyBtnTxt: "",

            // COMPONENTS
            homePage: true,
            getStartedPg: true,
            homeList: false,
            homeTopButtons: true,
            allTasks: true,
            taskTrailTasks: false,
            addingItem: false,
            itemAddedSuccessfully: false,
            showIncompleteBtn: true,
            confirmDelete: false,
            showAddExamples: false,
            showAddExampleBtn: true,
            writeExample: false,
            taskButtons: true,
            saveButtons: false,
            showTaskTrailBtn: true,
            goSlowMode: false,
            showGoSlowBtn: true,

                // DEMOS
            newUser: false,
            newTask: false,
            maximizeDemo: false,
            maximizeTutorialSeen: null,
            greyDemo: false,
            greyTutorialSeen: null,
            saveDemo: false,
            saveTutorialSeen: null,

            // TASK TRAIL
            taskTrailBtn: "Task Trails 🐛",

            // SLOW MODE
            slowModeBtn: "Go-Slow Mode 🚶‍♂️",
            bothArrays: [],
            slowModeTask: [],
            
            // TOGGLES
            task: "",
            difficulty: "",
            category: "",
            priority: "",

            // DIFFICULTY BTN COLORS
            manageableBgColor: "white",
            manageableTxtColor: "black",
            kindaHardBgColor: "white",
            kindaHardTxtColor: "black",
            hardBgColor: "white",
            hardTxtColor: "black",
            veryHardBgColor: "white",
            veryHardTxtColor: "black",
            superHardBgColor: "white",
            superHardTxtColor: "black",

            // CATEGORY BUTTON COLORS
            relationshipBgColor: "white",
            relationshipTxtColor: "black",
            mentalBgColor: "white",
            mentalTxtColor: "blac",
            physicalBgColor: "white",
            physicalTxtColor: "black",
            spiritualBgColor: "white",
            spiritualTxtColor: "black",
            regTodoBgColor: "white",
            regTodoTxtColor: "black",

            // PRIORITY BTN COLORS
            lowPriorityBgColor: "white",
            lowPriorityTxtColor: "black",
            highPriorityBgColor: "white",
            highPriorityTxtColor: "black",

            // ERROR MESSAGES
            taskErrMsg: "",
            difficultyErrMsg: "(The diffficulty section ☝️ is optional)",
            categoryErrMsg: "",
            priorityErrMsg: "",

            // TASK COMPLETE BUTTON
            taskCompleteBgColor: "#FFF",
            taskCompleteTxtColor: "black",
            allTaskTxtColor: "black"
        }
    }

    componentDidMount = () => {
        this.authListener()
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                this.loadTasks(user.email)
                this.loadTutorials(user.email)
            } else {
                this.setState({user:null})
            }
        })
    }

    loadTutorials = (email) => {
            // - - INTRO - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("intro")
        .get().then(doc => {
            if (doc.exists) {
                if (doc.data().seen == false) {
                    this.setState({
                        newUser: true
                    })
                } else {
                    this.setState({
                        newUser: false
                    })
                }
            } else {
                fire.firestore().collection("users")
                .doc(email)
                .collection("tutorials")
                .doc("intro")
                .set({
                    seen: false
                })
                this.setState({
                    newTask: true
                })
            }
        })

            // - - NEW TASK - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("newTask")
        .get().then(doc => {
            if (doc.exists) {
                if (doc.data().seen === false) {
                    this.setState({
                        newTask: true
                    })
                } else {
                    this.setState({
                        newTask: false
                    })
                }
            } else {
                fire.firestore().collection("users")
                .doc(email)
                .collection("tutorials")
                .doc("newTask")
                .set({
                    seen: false
                })
                this.setState({
                    newTask: true
                })
            }
        })

            // - - MAXIMIZE DEMO - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("maximizeDemo")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    maximizeTutorialSeen: doc.data().seen
                })
            }
        })

            // - - GREY DEMO - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("greyDemo")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    greyTutorialSeen: doc.data().seen
                })
            }
        })

            // - - SAVE DEMO - - //
        fire.firestore().collection("users")
        .doc(email)
        .collection("tutorials")
        .doc("saveDemo")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    saveTutorialSeen: doc.data().seen
                })
            }
        })
    }

    authListener = () => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    userEmail: user.email
                })
                fire.firestore().collection("users")
                .doc(user.email)
                .collection("tutorials")
                .doc("intro")
                .get().then(doc => {
                    if (doc.exists) {
                        this.setState({
                            getStartedPg: false,
                            homeList: true
                        })
                    } else {
                       console.log("don't recognize user")
                    }
                })
                // this.loadTutorials(user.email)
            } else {
                this.setState({user:null})
            }
        })
    }

    loadTasks = (email, taskID) => {
        class UserTask {
            constructor(bgColorCode, category, completed, completeBtns,
                completeTaskBtn,deleting, difficulty, exampleErrMsg, 
                exampleInput, exampleList, examples, greySetting, id,
                minimizeStatus, notes, notesCopied, priority, 
                saveBtn, saveNote, saveTask, task, taskIcon, txtColorCode) {
                this.bgColorCode = bgColorCode
                this.category = category
                this.completed = completed
                this.completeBtns = completeBtns
                this.completeTaskBtn = completeTaskBtn
                this.deleting = deleting
                this.difficulty = difficulty
                this.exampleErrMsg = exampleErrMsg
                this.exampleInput = exampleInput
                this.exampleList = exampleList
                this.examples = examples
                this.greySetting = greySetting
                this.id = id
                this.minimizeStatus = minimizeStatus
                this.notes = notes
                this.notesCopied = notesCopied
                this.priority = priority
                this.saveBtn = saveBtn
                this.saveNote = saveNote
                this.saveTask = saveTask
                this.task = task
                this.taskIcon = taskIcon
                this.txtColorCode = txtColorCode
            }
            toString() {
                return this.bgColorCode + ', ' +
                this.category + ', ' +
                this.completed + ', ' +
                this.completeBtns + ', ' +
                this.completeTaskBtn + ', ' +
                this.deleting + ', ' +
                this.difficulty + ', ' +
                this.exampleErrMsg + ', ' +
                this.exampleInput + ', ' +
                this.exampleList + ', ' +
                this.examples + ', ' +
                this.greySetting + ', ' +
                this.id + ', ' +
                this.minimizeStatus, + ', ' +
                this.notes + ', ' +
                this.notesCopied + ', ' +
                this.priority + ', ' +
                this.saveBtn  + ', ' +
                this.saveNote + ', ' +
                this.saveTask + ', ' +
                this.task + ', ' + 
                this.taskIcon + ', ' +
                this.txtColorCode
            }
        }
        var taskConverter = {
            toFirestore : function(task) {
                return {
                    bgColorCode: task.bgColorCode,
                    category: task.category,
                    completed: task.completed,
                    completeBtns: task.completeBtns,
                    completeTaskBtn: task.completeTaskBtn,
                    deleting: task.deleting,
                    difficulty: task.difficulty,
                    exampleErrMsg: task.exampleErrMsg,
                    exampleInput: task.exampleInput,
                    exampleList: task.exampleList,
                    examples: task.examples,
                    greySetting: task.greySetting,
                    id: task.id,
                    minimizeStatus: task.minimizeStatus,
                    notes: task.notes,
                    notesCopied: task.notesCopied,
                    priority: task.priority,
                    saveBtn: task.saveBtn,
                    saveNote: task.saveNote,
                    saveTask: task.saveTask,
                    task: task.task,
                    taskIcone: task.taskIcon,
                    txtColorCode: task.txtColorCode
                }
            },
            fromFirestore: function (snapshot, options) {
                const data = snapshot.data(options)
                return new UserTask(data.bgColorCode, data.category, data.completed, 
                    data.completeBtns, data.completeTaskBtn, data.deleting, data.difficulty, 
                    data.exampleErrMsg, data.exampleInput, data.exampleList,
                    data.examples, data.greySetting, data.id, data.minimizeStatus, 
                    data.notes, data.notesCopied, data.priority, data.saveBtn, data.saveNote, 
                    data.saveTask, data.task, data.taskIcon, data.txtColorCode)
            }
        }
        console.log(taskID)
        if (this.state.homeTxt == "Go-Slow Mode 🚶‍♂️") {
            console.log(taskID)
            fire.firestore().collection("users")
            .doc(email)
            .collection("tasks")
            .doc(taskID)
            .withConverter(taskConverter)
            .get().then(doc => {
                console.log(doc.data())
                if (doc.exists) {
                    this.state.slowModeTask = []
                    this.state.slowModeTask = this.state.slowModeTask.concat(doc.data())
                }
            })
        }

        fire.firestore().collection("users")
        .doc(email)
        .collection("tasks")
        .withConverter(taskConverter)
        .where('priority', '==', 'Low Priority')
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data())
            this.setState({
                lowPriorityTasks: data
            })
        })

        fire.firestore().collection("users")
        .doc(email)
        .collection("tasks")
        .withConverter(taskConverter)
        .where('priority', '==', 'High Priority')
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data())
            this.setState({
                highPriorityTasks: data
            })
        })
    }

    goToDeleteTask = (id) => {
       fire.firestore().collection("users")
       .doc(this.state.userEmail)
       .collection("tasks")
       .doc(id)
       .update({
           deleting: true,
           completeBtns: false
       })
       this.loadTasks(this.state.userEmail, id)
    }

    deleteTask = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tasks")
        .doc(id).delete()
        if (this.state.homeTxt == "Go-Slow Mode 🚶‍♂️") {
            this.setState({
                homeTopButtons: true,
                allTasks: true,
                showTaskTrailBtn: true,
                showGoSlowBtn: true,
                goSlowMode: false,
                slowModeBtn: "Go-Slow Mode 🚶‍♂️",
                homeTxt: "Home"
            })
        }
        this.loadTasks(this.state.userEmail, id)
    }

    cancelDelete = (id) => {
        fire.firestore().collection("users")
       .doc(this.state.userEmail)
       .collection("tasks")
       .doc(id)
       .update({
           deleting: false,
           completeBtns: true
       })
       this.loadTasks(this.state.userEmail, id)
    }

    taskComplete = (taskID, completed) => {
        if (completed == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(taskID)
            .update({
                completed: true,
                bgColorCode: "#6bcc04",
                txtColorCode: "#724E39",
                completeTaskBtn: "✅ Successfully Completed"
            })
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(taskID)
            .update({
                completed: false,
                bgColorCode: "#B8B8B8",
                txtColorCode: "#5E5E5E",
                completeTaskBtn: "Task Complete"
            })
        }
        this.loadTasks(this.state.userEmail, taskID)
    }

    addingExamples = (id, exampleTxt) => {
        if (exampleTxt == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                examples: true,
                exampleList: true,
            })
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                examples: false,
                exampleList: false,
                exampleInput: false,
                completeBtns: true
            })
        }
        this.loadTutorials(this.state.userEmail)
        this.loadExamples(id)
        this.loadTasks(this.state.userEmail, id)
    }

    addExampleClicked = (id, exampleInput) => {
        if (exampleInput == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                completeBtns: false,
                exampleInput: true
            })
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                completeBtns: true,
                exampleInput: false
            })
        }
        this.loadTasks(this.state.userEmail, id)
    }

    cancelExampleInput = (id) => {
        fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                exampleInput: false,
                completeBtns: true,
                exampleErrMsg: "",
                notesCopied: false
        })
        this.loadTasks(this.state.userEmail, id)
    }

    loadExamples = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tasks")
        .doc(id)
        .collection("examples")
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data().example)
            this.setState({
                taskExamples: data
            })
        })
    }
 
    submitExample = (id, userInput) => {
        if (!userInput == "") {
            fire.firestore().collection("users")
                .doc(this.state.userEmail)
                .collection("tasks")
                .doc(id)
                .update({
                    exampleErrMsg: `Your notes have been updated`
            })
            fire.firestore().collection("users")
                .doc(this.state.userEmail)
                .collection("tasks")
                .doc(id)
                .update({
                    notes: userInput,
                    notesCopied: false
            })
        } else {
            fire.firestore().collection("users")
                .doc(this.state.userEmail)
                .collection("tasks")
                .doc(id)
                .update({
                    exampleErrMsg: `Please enter some notes`
            })
        }
        this.setState({
            userExampleInput: ""
        })
        this.loadTasks(this.state.userEmail, id)
    }

    minimizeTaskCard = (id, status) => {
        if (status == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                minimizeStatus: true,
                saveBtn: false
            })
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                minimizeStatus: false
            })
        }
        this.loadTasks(this.state.userEmail, id)
        if(this.state.maximizeTutorialSeen == false) {
            this.setState({
                maximizeDemo: true
            })
        } else {
            return
        }
        console.log(id)
        this.loadTutorials(this.state.userEmail)
    }

    turnTaskGrey = (id, bgColor, completed) => {
        console.log(completed)
        if (bgColor == "#F5DE89" || bgColor == "#6BCC04") {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                bgColorCode: "#B8B8B8",
                txtColorCode: "#5E5E5E"
            })
        } else if (completed == true) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                bgColorCode: "#6BCC04",
                txtColorCode: "#724E39"
            })
        } else if (bgColor == "#B8B8B8") {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                bgColorCode: "#F5DE89",
                txtColorCode: "#724E39"
            })
        }
        this.loadTasks(this.state.userEmail, id)
        if(this.state.greyTutorialSeen == false) {
            this.setState({
                greyDemo: true
            })
        } else {
            return
        }
        this.loadTutorials(this.state.userEmail)
    }

    saveBtnClicked = (id, saveButton) => {
        if (saveButton == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                saveBtn: true,
                minimizeStatus: false
            })
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                saveBtn: false
            })
        }
        this.loadTasks(this.state.userEmail, id)
        if(this.state.saveTutorialSeen == false) {
            this.setState({
                saveDemo: true
            })
        } else {
            return
        }
        this.loadTutorials(this.state.userEmail, id)
    }

    saveTaskToDb = (id, task, category, difficulty, priority) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id)
        .set({
            id: id,
            task: task,
            category: category,
            difficulty: difficulty,
            priority: priority,
            deleting: false,
            taskErrMsg: ""
        })
    }

    deleteTaskFromDb = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedTasks")
        .doc(id).delete()
    }

    saveTaskClicked = (id, saveTask, task, category, difficulty, priority) => {
        if (saveTask == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                saveTask: true
            })
            this.saveTaskToDb(id, task, category, difficulty, priority)
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                saveTask: false
            })
            this.deleteTaskFromDb(id)
        }
        this.loadTasks(this.state.userEmail, id)
    }

    saveNoteToDb = (id, note) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedNotes")
        .doc(id)
        .set({
            copyBtn: "Copy",
            copyMsg: "",
            note: note,
            id: id,
            date: new Date().toString(),
            deleting: false
        })
    }

    deleteNoteFromDb = (id) => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("savedNotes")
        .doc(id).delete()
    }

    saveNoteClicked = (id, note, theNotes) => {
        if (note == false) {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                saveNote: true
            })
            this.saveNoteToDb(id, theNotes)
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                saveNote: false
            })
            this.deleteNoteFromDb(id)
        }
        this.loadTasks(this.state.userEmail, id)
    }

    copyingNotes = (id, notes, notesCopied) => {
        if (!notes == "") {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                notesCopied: true
            })
            copy(notes)
        } else {
            fire.firestore().collection("users")
            .doc(this.state.userEmail)
            .collection("tasks")
            .doc(id)
            .update({
                exampleErrMsg: "No existing notes to copy"
            })
        }
        this.loadTasks(this.state.userEmail, id)
    }

    renderHPTasks = () => {
        if (this.state.highPriorityTasks.length!= 0) {
            return this.state.highPriorityTasks.map(tasks => {
                var {bgColorCode, category, minimizeStatus,
                    completed, completeBtns, completeTaskBtn, deleting,
                    difficulty, exampleErrMsg, examples, exampleList, greySetting,
                    exampleInput, id, notes, priority, saveBtn, saveNote, saveTask, 
                    task, taskIcon, txtColorCode, notesCopied} = tasks
                    
                if (category == "Relationships") {
                    category = "Relationships 🤝"
                    taskIcon = "🤝"
                    if (priority == "High Priority") {
                        taskIcon = "🤝 💎"
                    }
                } else if (category == "Mental") {
                    category = "Mental 🧠"
                    taskIcon = "🧠"
                    if (priority == "High Priority") {
                        taskIcon = "🧠 💎"
                    }
                } else if (category == "Physical") {
                    category = "Physical ❤️"
                    taskIcon = "❤️"
                    if (priority == "High Priority") {
                        taskIcon = "❤️ 💎"
                    }
                } else if (category == "Spiritual") {
                    category = "Spiritual 🙏"
                    taskIcon = "🙏"
                    if (priority == "High Priority") {
                        taskIcon = "🙏 💎"
                    }
                } else if (category == "General") {
                    category = "General 📝"
                    taskIcon = "📝"
                    if (priority == "High Priority") {
                        taskIcon = "📝 💎"
                    }
                }

                if (notesCopied == true) {
                    this.state.noteCopyBtnTxt = "Copied ✅"
                } else {
                    this.state.noteCopyBtnTxt = "Copy Existing Notes"
                }

                if (saveBtn == false) {
                    this.state.saveButtons = false
                } else {
                    this.state.saveButtons = true
                }

                if (saveTask == false) {
                    this.state.saveTaskTxt = "Save Task"
                } else {
                    this.state.saveTaskTxt = "Task Saved ✅"
                }

                if (saveNote == false) {
                    this.state.saveNoteTxt = "Save Note"
                } else {
                    this.state.saveNoteTxt = "Note Saved ✅"
                }

                if (bgColorCode == "#B8B8B8") {
                    greySetting = "Undo"
                } else {
                    greySetting = "Grey"
                }

                if (completed == false && greySetting == "") {
                    this.state.taskComplete = ""
                    bgColorCode = "#F5DE89"
                    completeTaskBtn = "Task Complete"
                } else if (completed == true && greySetting == "") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    bgColorCode = "#6BCC04"
                    completeTaskBtn = "Successfully Completed ✅"
                } else if (completed == true && greySetting == "Grey") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    bgColorCode = "#6BCC04"
                    completeTaskBtn = "Successfully Completed ✅"
                } else if (completed == false && greySetting == "Grey") {
                    this.state.taskComplete = ""
                    bgColorCode = "#F5DE89"
                    completeTaskBtn = "Task Complete"
                } else if (completed == false && greySetting == "Undo") {
                    this.state.taskComplete = ""
                    completeTaskBtn = "Task Complete"
                } else if (completed == true && greySetting == "Undo") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    completeTaskBtn = "Successfully Completed ✅"
                }


                if (minimizeStatus == true) {
                    this.state.taskButtons = true
                    this.state.minimizeTxt = "Minimize"
                }  else {
                    this.state.taskButtons = false
                    this.state.minimizeTxt = "Maximize"
                }


                if (examples == true) {
                    this.state.showAddExamples = true
                    this.state.exampleTxt = "Hide Notes"
                } else {
                    this.state.showAddExamples = false
                    this.state.exampleTxt = "Show Notes"
                }

                if (exampleInput == true) {
                    this.state.writeExample = true
                } else {
                    this.state.writeExample = false
                    // this.state.showIncompleteBtn = true
                }

                if (deleting == false) {
                    this.state.showIncompleteBtn = true
                    this.state.confirmDelete = false
                } else {
                    this.state.showIncompleteBtn = false
                    this.state.confirmDelete = true
                }

                if (completeBtns == false) {
                    this.state.showIncompleteBtn = false
                } else {
                    this.state.showIncompleteBtn = true
                }

                if (difficulty == "Manageable") {
                    difficulty = "👍"
                } else if (difficulty == "Challenging") {
                    difficulty = "🧨"
                } else if (difficulty == "Hard") {
                    difficulty = "🧨🧨"
                } else if (difficulty == "Very Hard") {
                    difficulty = "🧨🧨🧨"
                } else if (difficulty == "Super Hard") {
                    difficulty = "💣"
                }

                let taskStyle = {
                    backgroundColor: bgColorCode
                }

                let taskTxtColor = {
                    color: txtColorCode,
                    fontFamily: "DM Sans"
                }

                console.log(bgColorCode)

                let taskCompleteLabel = {
                    marginLeft: "2%"
                }

                let completeBtnStyle = {
                    backgroundColor: this.state.taskCompleteBgColor,
                    color: this.state.taskCompleteTxtColor
                }

                let difficultyLabel = {
                    marginRight: "2%",
                    color: txtColorCode
                }

                let categoryContainer = {
                    textAlign: "left",
                    marginRight: "50%",
                }

                let categoryBtn = {
                    color: txtColorCode,
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                    padding: "3%",
                    border: `0px solid ${txtColorCode}`,
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    marginBottom: "5.5%"
                }

                // const { width, height } = useWindowSize()

                return(
                    <Styles>
                        <div style={taskStyle} className='allTasks'>
                            <div className='taskInfo'>
                                <div className='hideItems'>
                                    <button
                                    onClick={() => this.minimizeTaskCard(id, minimizeStatus)}
                                    ><label style={taskTxtColor}>{this.state.minimizeTxt}</label></button>
                                    <button
                                    onClick={() => this.turnTaskGrey(id, bgColorCode, completed)}
                                    ><label style={taskTxtColor}>{greySetting}</label></button>
                                    <button
                                    onClick={() => this.saveBtnClicked(id, saveBtn)}
                                    ><label style={taskTxtColor}>Save</label></button>
                                </div>
                                <div className='taskLabel'>
                                    {/* <img src="assets/flag.png"/> */}
                                    <h5 style={taskTxtColor} ><b>task - <label>{taskIcon}</label></b></h5>
                                </div>
                                <div className='taskData'>
                                    <div className="taskDataChild">
                                        <p>{task}
                                        <label style={taskCompleteLabel}>{this.state.taskComplete}</label></p>
                                    </div>
                                    {exampleList && 
                                        <div className="taskDataChild2">
                                            <p style={taskTxtColor}>Notes</p>
                                            <textarea
                                            value={notes}
                                            readOnly/>
                                        </div>
                                    }
                                </div>
                                {this.state.maximizeDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.maximizeDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                            <h4>You can add additional notes to tasks as you work on them</h4>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/maximizeDemo1.mp4" type="video/mp4"/>
                                            </video>     
                         
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.greyDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.greyDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                        <h4>You can move tasks to the background by 'greying' them, to focus on tasks at hand</h4>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/greyDemo1.mp4" type="video/mp4"/>
                                            </video>     
                         
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.saveDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.saveDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                        <h4>You can also save tasks you want to re-add to your list later, as well as save notes that you make throughout the day</h4>
                                            <p>See how to do this below 👀</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/saveDemo1.mp4" type="video/mp4"/>
                                            </video>
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.taskButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button style={categoryBtn}>
                                                Difficulty: {difficulty}
                                            </button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{category}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{priority} 💎</button>
                                        </div>
                                        {this.state.showAddExampleBtn && 
                                            <div style={categoryContainer} className='taskCategory'>
                                                <button  
                                                onClick={() => this.addingExamples(id, examples)}
                                                style={categoryBtn}>{this.state.exampleTxt}</button>
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.saveButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveTaskClicked(id, 
                                            saveTask, task, category, difficulty, 
                                            priority)}
                                            style={categoryBtn}
                                            >{this.state.saveTaskTxt}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveNoteClicked(id, saveNote, notes)}
                                            style={categoryBtn}
                                            >{this.state.saveNoteTxt}</button>
                                        </div>
                                    </div>
                                }  
                            </div>
                            <div className='markComplete'>
                                <ShowMoreText
                                /* Default options */
                                lines={1}
                                more="Mark as Complete"
                                less="Hide"
                                className="content-css"
                                anchorClass="my-anchor-css-class"
                                // onClick={this.executeOnClick}
                                expanded={false}
                                width={10}
                                truncatedEndingComponent={""}
                                >
                                {this.state.showIncompleteBtn && 
                                    <div className="taskBtnAction">
                                        {this.state.showAddExamples && 
                                            <div>
                                                <button
                                                onClick={() => this.addExampleClicked(id, exampleInput)}
                                                style={completeBtnStyle}
                                                >Add Notes</button>
                                            </div>
                                        }
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.taskComplete(id, completed)}
                                        >{completeTaskBtn}</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.goToDeleteTask(id)}
                                        >Delete ❌</button>
                                    </div>
                                }
                                {this.state.confirmDelete && 
                                    <div className="taskBtnAction">
                                        <p style={taskTxtColor}>Are you sure you want to delete this task?</p>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTask(id)}
                                        >Yes ✅</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.cancelDelete(id)}
                                        >No ❌</button>
                                    </div>
                                }
                                {this.state.writeExample && 
                                    <div className="taskBtnAction2">
                                        <div>
                                            <div className='noteCopyBtn'>
                                                <button
                                                onClick={() => this.copyingNotes(id, notes, notesCopied)}
                                                >{this.state.noteCopyBtnTxt}</button>
                                            </div>
                                            <p style={taskTxtColor}>{exampleErrMsg}</p>
                                            <textarea
                                            rows="3"
                                            placeholder="Enter your notes here"
                                            id="userExampleInput"
                                            value={this.state.userExampleInput}
                                            onChange={this.handleChange}
                                            />
                                            <br/>
                                            <button
                                            onClick={() => this.submitExample(id, this.state.userExampleInput)}
                                            style={completeBtnStyle}
                                            >Update</button>
                                            <br/>
                                            <button
                                            onClick={() => this.cancelExampleInput(id)}
                                            style={completeBtnStyle}
                                            >Close</button>
                                        </div>
                                    </div>
                                }
                                {/* <p>{completed}</p> */}
                                </ShowMoreText>
                                <h4>*space*</h4>
                            </div>
                        </div>
                    </Styles>
                )
            })
        }
    }

    renderLPTasks = () => {
        if (this.state.lowPriorityTasks.length!= 0) {
            return this.state.lowPriorityTasks.map(tasks => {
                var {bgColorCode, category, minimizeStatus, completeBtns,
                    completed, completeTaskBtn, deleting, saveBtn, saveNote, saveTask, 
                    difficulty, exampleErrMsg, examples, exampleList, greySetting, 
                    exampleInput, id, notes, priority, task, taskIcon, txtColorCode,
                    notesCopied} = tasks


                if (category == "Relationships") {
                    category = "Relationships 🤝"
                    taskIcon = "🤝 📌"
                } else if (category == "Mental") {
                    category = "Mental 🧠"
                    taskIcon = "🧠 📌"
                } else if (category == "Physical") {
                    category = "Physical ❤️"
                    taskIcon = "❤️ 📌"
                } else if (category == "Spiritual") {
                    category = "Spiritual 🙏"
                    taskIcon = "🙏 📌"
                } else if (category == "General") {
                    category = "General 📝"
                    taskIcon = "📝 📌"
                }

                if (notesCopied == true) {
                    this.state.noteCopyBtnTxt = "Copied ✅"
                } else {
                    this.state.noteCopyBtnTxt = "Copy Existing Notes"
                }

                if (saveBtn == false) {
                    this.state.saveButtons = false
                } else {
                    this.state.saveButtons = true
                }

                if (saveTask == false) {
                    this.state.saveTaskTxt = "Save Task"
                } else {
                    this.state.saveTaskTxt = "Task Saved ✅"
                }

                if (saveNote == false) {
                    this.state.saveNoteTxt = "Save Note"
                } else {
                    this.state.saveNoteTxt = "Note Saved ✅"
                }

                if (minimizeStatus == true) {
                    this.state.taskButtons = true
                    this.state.minimizeTxt = "Minimize"
                }  else {
                    this.state.taskButtons = false
                    this.state.minimizeTxt = "Maximize"
                }

                if (bgColorCode == "#B8B8B8") {
                    greySetting = "Undo"
                } else {
                    greySetting = "Grey"
                }

                if (completed == false && greySetting == "") {
                    this.state.taskComplete = ""
                    bgColorCode = "#F5DE89"
                    completeTaskBtn = "Task Complete"
                } else if (completed == true && greySetting == "") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    bgColorCode = "#6BCC04"
                    completeTaskBtn = "Successfully Completed ✅"
                } else if (completed == true && greySetting == "Grey") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    bgColorCode = "#6BCC04"
                    completeTaskBtn = "Successfully Completed ✅"
                } else if (completed == false && greySetting == "Grey") {
                    this.state.taskComplete = ""
                    bgColorCode = "#F5DE89"
                    completeTaskBtn = "Task Complete"
                } else if (completed == false && greySetting == "Undo") {
                    this.state.taskComplete = ""
                    completeTaskBtn = "Task Complete"
                } else if (completed == true && greySetting == "Undo") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    completeTaskBtn = "Successfully Completed ✅"
                }

                if (examples == true) {
                    this.state.showAddExamples = true
                    this.state.exampleTxt = "Hide Notes"
                } else {
                    this.state.showAddExamples = false
                    this.state.exampleTxt = "Show Notes"
                }

                if (exampleInput == true) {
                    this.state.writeExample = true
                } else {
                    this.state.writeExample = false
                }

                if (deleting == false) {
                    this.state.showIncompleteBtn = true
                    this.state.confirmDelete = false
                } else {
                    this.state.showIncompleteBtn = false
                    this.state.confirmDelete = true
                }

                if (completeBtns == false) {
                    this.state.showIncompleteBtn = false
                } else {
                    this.state.showIncompleteBtn = true
                }

                if (difficulty == "Manageable") {
                    difficulty = "👍"
                } else if (difficulty == "Challenging") {
                    difficulty = "🧨"
                } else if (difficulty == "Hard") {
                    difficulty = "🧨🧨"
                } else if (difficulty == "Very Hard") {
                    difficulty = "🧨🧨🧨"
                } else if (difficulty == "Super Hard") {
                    difficulty = "💣"
                }

                let taskStyle = {
                    backgroundColor: bgColorCode
                }

                let taskTxtColor = {
                    color: txtColorCode,
                    fontFamily: "DM Sans"
                }

                let taskCompleteLabel = {
                    color: txtColorCode,
                    marginLeft: "2%"
                }

                let completeBtnStyle = {
                    backgroundColor: this.state.taskCompleteBgColor,
                    color: this.state.taskCompleteTxtColor
                }

                let difficultyLabel = {
                    marginRight: "2%",
                    color: txtColorCode
                }

                let categoryContainer = {
                    textAlign: "left",
                    marginRight: "50%"
                }

                let categoryBtn = {
                    color: txtColorCode,
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                    padding: "3%",
                    border: `0px solid ${txtColorCode}`,
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    marginBottom: "5.5%"
                }

                return(
                    <Styles>
                        <div style={taskStyle} className='allTasks'>
                            <div className='taskInfo'>
                                <div className='hideItems'>
                                    <button
                                    onClick={() => this.minimizeTaskCard(id, minimizeStatus)}
                                    ><label style={taskTxtColor}>{this.state.minimizeTxt}</label></button>
                                    <button
                                    onClick={() => this.turnTaskGrey(id, bgColorCode, completed)}
                                    ><label style={taskTxtColor}>{greySetting}</label></button>
                                    <button
                                    onClick={() => this.saveBtnClicked(id, saveBtn)}
                                    ><label style={taskTxtColor}>Save</label></button>
                                </div>
                                <div className='taskLabel'>
                                    <h5 style={taskTxtColor} color={txtColorCode}><b>task - <label>{taskIcon}</label></b></h5>
                                </div>
                                <div className='taskData'>
                                    <div className="taskDataChild">
                                        <p>{task}
                                        <label style={taskCompleteLabel}>{this.state.taskComplete}</label></p>
                                    </div>
                                    {exampleList && 
                                        <div className="taskDataChild2">
                                            <p style={taskTxtColor} >Notes</p>
                                            <textarea
                                            value={notes}
                                            readOnly/>
                                        </div>
                                    }
                                </div>
                                {this.state.maximizeDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.maximizeDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                            <h4>You can add additional notes to tasks as you work on them</h4>
                                            <p>See how to do this below👀</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/maximizeDemo1.mp4" type="video/mp4"/>
                                            </video>     
                         
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.greyDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.greyDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                            <h4>You can move tasks to the background by 'greying' them, to focus on tasks at hand</h4>
                                            <p>See how to do this below 👀</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/greyDemo1.mp4" type="video/mp4"/>
                                            </video>     
                         
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.saveDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.saveDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                            <h4>You can also save tasks you want to re-add to your list later, as well as save notes that you make throughout the day</h4>
                                            <p>See how to do this below 👀</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/saveDemo1.mp4" type="video/mp4"/>
                                            </video>
                         
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.taskButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button style={categoryBtn}>
                                                Difficulty: {difficulty}
                                            </button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{category}</button>
                                        </div>
                                        {this.state.showAddExampleBtn && 
                                            <div style={categoryContainer} className='taskCategory'>
                                                <button  
                                                onClick={() => this.addingExamples(id, examples)}
                                                style={categoryBtn}>{this.state.exampleTxt}</button>
                                            </div>
                                        }
                                </div>
                                }
                                {this.state.saveButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveTaskClicked(id, 
                                            saveTask, task, category, difficulty, 
                                            priority)}
                                            style={categoryBtn}
                                            >{this.state.saveTaskTxt}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveNoteClicked(id, saveNote, notes)}
                                            style={categoryBtn}
                                            >{this.state.saveNoteTxt}</button>
                                        </div>
                                    </div>
                                }  
                            </div>
                            <div className='markComplete'>
                                <ShowMoreText
                                /* Default options */
                                lines={1}
                                more="Mark as Complete"
                                less="Hide"
                                className="content-css"
                                anchorClass="my-anchor-css-class"
                                // onClick={this.executeOnClick}
                                expanded={false}
                                width={10}
                                truncatedEndingComponent={""}
                                >
                                {this.state.showIncompleteBtn && 
                                    <div className="taskBtnAction">
                                        {this.state.showAddExamples && 
                                            <div>
                                                <button
                                                onClick={() => this.addExampleClicked(id, exampleInput)}
                                                style={completeBtnStyle}
                                                >Add Notes</button>
                                            </div>
                                        }
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.taskComplete(id, completed)}
                                        >{completeTaskBtn}</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.goToDeleteTask(id)}
                                        >Delete ❌</button>
                                    </div>
                                }
                                {this.state.confirmDelete && 
                                    <div className="taskBtnAction">
                                        <p style={taskTxtColor}>Are you sure you want to delete this task?</p>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTask(id)}
                                        >Yes ✅</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.cancelDelete(id)}
                                        >No ❌</button>
                                    </div>
                                }
                                {exampleInput && 
                                    <div className="taskBtnAction2">
                                        <div>
                                            <div className='noteCopyBtn'>
                                                <button
                                                onClick={() => this.copyingNotes(id, notes, notesCopied)}
                                                >{this.state.noteCopyBtnTxt}</button>
                                            </div>
                                            <p style={taskTxtColor}>{exampleErrMsg}</p>
                                            <textarea
                                            rows="3"
                                            placeholder="Enter your notes here"
                                            id="userExampleInput"
                                            value={this.state.userExampleInput}
                                            onChange={this.handleChange}
                                            />
                                            <br/>
                                            <button
                                            onClick={() => this.submitExample(id, this.state.userExampleInput)}
                                            style={completeBtnStyle}
                                            >Update</button>
                                            <br/>
                                            <button
                                            onClick={() => this.cancelExampleInput(id)}
                                            style={completeBtnStyle}
                                            >Close</button>
                                        </div>
                                    </div>
                                }
                                {/* <p>{completed}</p> */}
                                </ShowMoreText>
                                <h4>*space*</h4>
                            </div>
                        </div>
                    </Styles>
                )
            })
        }
    }

    logOut = () => {
        fire.auth().signOut()
        window.location.href = "/"
    }

    goToItemAdd = () => {
        this.loadTutorials(this.state.userEmail)
        this.setState({
            homeList: false,
            addingItem: true,
        })
    }

    manageableClicked = () => {
        if (this.state.manageableBgColor == "white") {
            this.setState({
                manageableBgColor: "#724E39",
                manageableTxtColor: "white",
                kindaHardBgColor: "white",
                kindaHardTxtColor: "black",
                hardBgColor: "white",
                hardTxtColor: "black",
                veryHardBgColor: "white",
                veryHardTxtColor: "black",
                superHardBgColor: "white",
                superHardTxtColor: "black",
                difficulty: "Manageable"
            })
        } else {
            this.setState({
                manageableBgColor: "white",
                manageableTxtColor: "black",
                difficulty: ""
            })
        }
    }

    kindaHardClicked = () => {
        if (this.state.kindaHardBgColor == "white") {
            this.setState({
                manageableBgColor: "white",
                manageableTxtColor: "black",
                kindaHardBgColor: "#724E39",
                kindaHardTxtColor: "white",
                hardBgColor: "white",
                hardTxtColor: "black",
                veryHardBgColor: "white",
                veryHardTxtColor: "black",
                superHardBgColor: "white",
                superHardTxtColor: "black",
                difficulty: "Challenging"
            })
        } else {
            this.setState({
                kindaHardBgColor: "white",
                kindaHardTxtColor: "black",
                difficulty: ""
            })
        }
    }

    hardClicked = () => {
        if (this.state.hardBgColor == "white") {
            this.setState({
                manageableBgColor: "white",
                manageableTxtColor: "black",
                kindaHardBgColor: "white",
                kindaHardTxtColor: "black",
                hardBgColor: "#724E39",
                hardTxtColor: "white",
                veryHardBgColor: "white",
                veryHardTxtColor: "black",
                superHardBgColor: "white",
                superHardTxtColor: "black",
                difficulty: "Hard"
            })
        } else {
            this.setState({
                hardBgColor: "white",
                hardTxtColor: "black",
                difficulty: ""
            })
        }
    }

    veryHardClicked = () => {
        if (this.state.veryHardBgColor == "white") {
            this.setState({
                manageableBgColor: "white",
                manageableTxtColor: "black",
                kindaHardBgColor: "white",
                kindaHardTxtColor: "black",
                hardBgColor: "white",
                hardTxtColor: "black",
                veryHardBgColor: "#724E39",
                veryHardTxtColor: "white",
                superHardBgColor: "white",
                superHardTxtColor: "black",
                difficulty: "Very Hard"
            })
        } else {
            this.setState({
                veryHardBgColor: "white",
                veryHardTxtColor: "black",
                difficulty: ""
            })
        }
    }

    superHardClicked = () => {
        if (this.state.superHardBgColor == "white") {
            this.setState({
                manageableBgColor: "white",
                manageableTxtColor: "black",
                kindaHardBgColor: "white",
                kindaHardTxtColor: "black",
                hardBgColor: "white",
                hardTxtColor: "black",
                veryHardBgColor: "white",
                veryHardTxtColor: "black",
                superHardBgColor: "#724E39",
                superHardTxtColor: "white",
                difficulty: "Super Hard"
            })
        } else {
            this.setState({
                superHardBgColor: "white",
                superHardTxtColor: "black",
                difficulty: ""
            })
        }
    }

    relationshipClicked = () => {
        if (this.state.relationshipBgColor == "white") {
            this.setState({
                relationshipBgColor: "#724E39",
                relationshipTxtColor: "white",
                mentalBgColor: "white",
                mentalTxtColor: "black",
                physicalBgColor: "white",
                physicalTxtColor: "black",
                spiritualBgColor: "white",
                spiritualTxtColor: "black",
                regTodoBgColor: "white",
                regTodoTxtColor: "black",
                category: "Relationships"
            })
        } else {
            this.setState({
                relationshipBgColor: "white",
                relationshipTxtColor: "black",
                category: ""
            })
        }
    }

    mentalClicked = () => {
        if (this.state.mentalBgColor == "white") {
            this.setState({
                relationshipBgColor: "white",
                relationshipTxtColor: "black",
                mentalBgColor: "#724E39",
                mentalTxtColor: "white",
                physicalBgColor: "white",
                physicalTxtColor: "black",
                spiritualBgColor: "white",
                spiritualTxtColor: "black",
                regTodoBgColor: "white",
                regTodoTxtColor: "black",
                category: "Mental"
            })
        } else {
            this.setState({
                mentalBgColor: "white",
                mentalTxtColor: "black",
                category: ""
            })
        }
    }

    physicalClicked = () => {
        if (this.state.physicalBgColor == "white") {
            this.setState({
                relationshipBgColor: "white",
                relationshipTxtColor: "black",
                mentalBgColor: "white",
                mentalTxtColor: "black",
                physicalBgColor: "#724E39",
                physicalTxtColor: "white",
                spiritualBgColor: "white",
                spiritualTxtColor: "black",
                regTodoBgColor: "white",
                regTodoTxtColor: "black",
                category: "Physical"
            })
        } else {
            this.setState({
                physicalBgColor: "white",
                physicalTxtColor: "black",
                category: ""
            })
        }
    }

    spiritualClicked = () => {
        if (this.state.spiritualBgColor == "white") {
            this.setState({
                relationshipBgColor: "white",
                relationshipTxtColor: "black",
                mentalBgColor: "white",
                mentalTxtColor: "black",
                physicalBgColor: "white",
                physicalTxtColor: "black",
                spiritualBgColor: "#724E39",
                spiritualTxtColor: "white",
                regTodoBgColor: "white",
                regTodoTxtColor: "black",
                category: "Spiritual"
            })
        } else {
            this.setState({
                spiritualBgColor: "white",
                spiritualTxtColor: "black",
                category: ""
            })
        }
    }

    generalClicked = () => {
        if (this.state.regTodoBgColor == "white") {
            this.setState({
                relationshipBgColor: "white",
                relationshipTxtColor: "black",
                mentalBgColor: "white",
                mentalTxtColor: "black",
                physicalBgColor: "white",
                physicalTxtColor: "black",
                spiritualBgColor: "white",
                spiritualTxtColor: "black",
                regTodoBgColor: "#724E39",
                regTodoTxtColor: "white",
                category: "General"
            })
        } else {
            this.setState({
                regTodoBgColor: "white",
                regTodoTxtColor: "black",
                category: ""
            })
        }
    }

    lowPriorityClicked = () => {
        if (this.state.lowPriorityBgColor == "white") {
            this.setState({
                lowPriorityBgColor: "#724E39",
                lowPriorityTxtColor: "white",
                highPriorityBgColor: "white",
                highPriorityTxtColor: "black",
                priority: "Low Priority"
            })
        } else {
            this.setState({
                lowPriorityBgColor: "white",
                lowPriorityTxtColor: "black",
                priority: ""
            })
        }
    }

    highPriorityClicked = () => {
        if (this.state.highPriorityBgColor == "white") {
            this.setState({
                lowPriorityBgColor: "white",
                lowPriorityTxtColor: "black",
                highPriorityBgColor: "#724E39",
                highPriorityTxtColor: "white",
                priority: "High Priority"
            })
        } else {
            this.setState({
                highPriorityBgColor: "white",
                highPriorityTxtColor: "black",
                priority: ""
            })
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

    submitTask = () => {
        if (!this.state.task == "" && 
            !this.state.category == "" && 
            !this.state.priority == "") {
                this.setState({
                    taskErrMsg: "",
                    categoryErrMsg: "",
                    priorityErrMsg: ""
                })
                let taskID = shortid.generate()
                if (!this.state.difficulty == "") {
                    fire.firestore().collection("users")
                    .doc(this.state.userEmail)
                    .collection("tasks")
                    .doc(taskID)
                    .set({
                        id: taskID,
                        deleting: false,
                        bgColorCode: "#F5DE89",
                        txtColorCode: "#724E39",
                        completeTaskBtn: "Task Completed",
                        completeBtns: true,
                        examples: false,
                        exampleErrMsg: "",
                        exampleList: false,
                        exampleInput: false,
                        greySetting: false,
                        notes: "",
                        saveBtn: false,
                        saveNote: false,
                        saveTask: false,
                        task: this.state.task,
                        taskIcon: "",
                        minimizeStatus: false,
                        difficulty: this.state.difficulty,
                        category: this.state.category,
                        priority: this.state.priority,
                        completed: false
                    })
                    this.setState({
                        category: "",
                        difficulty: "",
                        priority: "",
                        task: "",
                        // DIFFICULTY BTN COLORS
                        manageableBgColor: "white",
                        manageableTxtColor: "black",
                        kindaHardBgColor: "white",
                        kindaHardTxtColor: "black",
                        hardBgColor: "white",
                        hardTxtColor: "black",
                        veryHardBgColor: "white",
                        veryHardTxtColor: "black",
                        superHardBgColor: "white",
                        superHardTxtColor: "black",

                        // CATEGORY BUTTON COLORS
                        relationshipBgColor: "white",
                        relationshipTxtColor: "black",
                        mentalBgColor: "white",
                        mentalTxtColor: "blac",
                        physicalBgColor: "white",
                        physicalTxtColor: "black",
                        spiritualBgColor: "white",
                        spiritualTxtColor: "black",
                        regTodoBgColor: "white",
                        regTodoTxtColor: "black",

                        // PRIORITY BTN COLORS
                        lowPriorityBgColor: "white",
                        lowPriorityTxtColor: "black",
                        highPriorityBgColor: "white",
                        highPriorityTxtColor: "black",
                        addingItem: false,
                        itemAddedSuccessfully: true
                    })
                } else {
                    fire.firestore().collection("users")
                    .doc(this.state.userEmail)
                    .collection("tasks")
                    .doc(taskID)
                    .set({
                        id: taskID,
                        deleting: false,
                        bgColorCode: "#F5DE89",
                        txtColorCode: "#724E39",
                        completeTaskBtn: "Task Completed",
                        completeBtns: true,
                        examples: false,
                        exampleErrMsg: "",
                        exampleList: false,
                        exampleInput: false,
                        notes: "",
                        saveBtn: false,
                        saveNote: false,
                        saveTask: false,
                        greySetting: false,
                        task: this.state.task,
                        taskIcon: "",
                        minimizeStatus: false,
                        difficulty: "Not Specified ",
                        completed: false,
                        category: this.state.category,
                        priority: this.state.priority
                    })
                    this.setState({
                        category: "",
                        difficulty: "",
                        priority: "",
                        task: "",
                        // DIFFICULTY BTN COLORS
                        manageableBgColor: "white",
                        manageableTxtColor: "black",
                        kindaHardBgColor: "white",
                        kindaHardTxtColor: "black",
                        hardBgColor: "white",
                        hardTxtColor: "black",
                        veryHardBgColor: "white",
                        veryHardTxtColor: "black",
                        superHardBgColor: "white",
                        superHardTxtColor: "black",

                        // CATEGORY BUTTON COLORS
                        relationshipBgColor: "white",
                        relationshipTxtColor: "black",
                        mentalBgColor: "white",
                        mentalTxtColor: "blac",
                        physicalBgColor: "white",
                        physicalTxtColor: "black",
                        spiritualBgColor: "white",
                        spiritualTxtColor: "black",
                        regTodoBgColor: "white",
                        regTodoTxtColor: "black",

                        // PRIORITY BTN COLORS
                        lowPriorityBgColor: "white",
                        lowPriorityTxtColor: "black",
                        highPriorityBgColor: "white",
                        highPriorityTxtColor: "black",
                        addingItem: false,
                        itemAddedSuccessfully: true
                    })
                }
        } else if (this.state.task == "" &&
                    !this.state.category == "" && 
                    !this.state.priority == "") {
                        this.setState({
                            taskErrMsg: "Please enter a task",
                            categoryErrMsg: "",
                            priorityErrMsg: ""
                        })
        } else if (!this.state.task == "" && 
                    this.state.category == "" && 
                    !this.state.priority == "") {
                        this.setState({
                            taskErrMsg: "",
                            categoryErrMsg: "Please select a category",
                            priorityErrMsg: ""
                        })
        } else if (!this.state.task == "" &&
                    !this.state.category == "" &&
                    this.state.priority == "") {
                        this.setState({
                            taskErrMsg: "",
                            categoryErrMsg: "",
                            priorityErrMsg: "Please select a priority level"
                        })
        } else if (!this.state.task == "" && 
                    this.state.category == "" && 
                    this.state.priority == "") {
                        this.setState({
                            taskErrMsg: "",
                            categoryErrMsg: "Please select a category",
                            priorityErrMsg: "Please select a priority level"
                        })

        } else if (this.state.task == "" &&
                    !this.state.category == "" &&
                    this.state.priority == "") {
                        this.setState({
                            taskErrMsg: "Please enter a task",
                            categoryErrMsg: "",
                            priorityErrMsg: "Please select a priority level"
                        })

        } else if (this.state.task == "" &&
                    this.state.category == "" && 
                    !this.state.priority == "") {
                        this.setState({
                            taskErrMsg: "Please enter a task",
                            categoryErrMsg: "Please enter a category",
                            priorityErrMsg: ""
                        })
        } else {
            this.setState({
                taskErrMsg: "Please enter a task",
                categoryErrMsg: "Please select a category",
                priorityErrMsg: "Please select a priority level"
            })
        }
    }

    backToList = () => {
        this.setState({
            homeList: true,
            itemAddedSuccessfully: false
        })
        this.loadTasks(this.state.userEmail)
    }

    addAnotherTask = () => {
        this.setState({
            addingItem: true,
            itemAddedSuccessfully: false
        })
    }

    cancelAdd = () => {
        this.setState({
            homeList: true,
            addingItem: false
        })
        this.loadTasks(this.state.userEmail)
    }

    goToDailyReport = () => {
        this.setState({
            homePage: false,
            dailyReport: true
        })
    }

    introTutorialSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("intro")
        .set({
            seen: true
        })
        this.loadTutorials(this.state.userEmail)
    }

    newTaskTutorialSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("newTask")
        .set({
            seen: true
        })
        this.loadTutorials(this.state.userEmail)
    }

    maximizeDemoSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("maximizeDemo")
        .set({
            seen: true
        })
        this.setState({
            maximizeDemo: false
        })
        this.loadTutorials(this.state.userEmail)
    }

    greyDemoSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("greyDemo")
        .set({
            seen: true
        })
        this.setState({
            greyDemo: false
        })
        this.loadTutorials(this.state.userEmail)
    }

    saveDemoSeen = () => {
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("saveDemo")
        .set({
            seen: true
        })
        this.setState({
            saveDemo: false
        })
        this.loadTutorials(this.state.userEmail)
    }

    getStartedClicked = () => {
        this.setState({
            getStartedPg: false,
            homeList: true
        })
        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("intro")
        .set({
            seen: false
        })

        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("maximizeDemo")
        .set({
            seen: false
        })

        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("greyDemo")
        .set({
            seen: false
        })

        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("saveDemo")
        .set({
            seen: false
        })

        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("noteSaveDemo")
        .set({
            seen: false
        })

        fire.firestore().collection("users")
        .doc(this.state.userEmail)
        .collection("tutorials")
        .doc("taskSaveDemo")
        .set({
            seen: false
        })

        this.loadTutorials(this.state.userEmail)
    }

    goToTaskTrail = () => {
        if (this.state.taskTrailBtn == "Task Trails 🐛") {
            this.setState({
                homeTopButtons: false,
                allTasks: false,
                showGoSlowBtn: false,
                taskTrailTasks: true,
                taskTrailBtn: "Back to Tasks",
                homeTxt: "Task Trails 🐛"
            })
        } else {
            this.setState({
                homeTopButtons: true,
                allTasks: true,
                taskTrailTasks: false,
                showGoSlowBtn: true,
                taskTrailBtn: "Task Trails 🐛",
                homeTxt: "Home"
            })
        }
        this.loadTasks(this.state.userEmail)
    }

    goToSlowMode = () => {
        if (this.state.slowModeBtn == "Go-Slow Mode 🚶‍♂️") {
            this.setState({
                homeTopButtons: false,
                allTasks: false,
                goSlowMode: true,
                showTaskTrailBtn: false,
                slowModeBtn: "Back to Tasks",
                homeTxt: "Go-Slow Mode 🚶‍♂️"
            })
            this.state.bothArrays = this.state.highPriorityTasks.concat(this.props.lowPriorityTasks)
            this.state.bothArrays = this.state.bothArrays.filter(function( obj ) {
                return obj !== undefined;
            })
            this.state.bothArrays = this.state.bothArrays.filter(task => {
                return task.completed == false
            })
            this.state.bothArrays = this.state.bothArrays.sort(() => Math.random() - 0.5);
            let firstElement = []
            firstElement = firstElement.concat(this.state.bothArrays[Object.keys(this.state.bothArrays)[0]])
            this.setState({
                slowModeTask : firstElement
            })
        } else {
            this.setState({
                homeTopButtons: true,
                allTasks: true,
                showTaskTrailBtn: true,
                showGoSlowBtn: true,
                goSlowMode: false,
                slowModeBtn: "Go-Slow Mode 🚶‍♂️",
                homeTxt: "Home"
            })
        }
        this.loadTasks(this.state.userEmail)
    }

    shuffleTasks = () => {
        this.state.bothArrays = this.state.bothArrays.sort(() => Math.random() - 0.5);
        let firstElement = []
        firstElement = firstElement.concat(this.state.bothArrays[Object.keys(this.state.bothArrays)[0]])
        this.setState({
            slowModeTask : firstElement
        })
    }

    renderSlowTasks = () => {
        if (!this.state.slowModeTask.length == 0) {
            return this.state.slowModeTask.map(tasks => {
                var {bgColorCode, category, minimizeStatus,
                    completed, completeBtns, completeTaskBtn, deleting,
                    difficulty, exampleErrMsg, examples, exampleList, greySetting,
                    exampleInput, id, notes, priority, saveBtn, saveNote, saveTask, 
                    task, taskIcon, txtColorCode, notesCopied} = tasks

                    
                if (category == "Relationships") {
                    category = "Relationships 🤝"
                    taskIcon = "🤝"
                    if (priority == "High Priority") {
                        taskIcon = "🤝 💎"
                    }
                } else if (category == "Mental") {
                    category = "Mental 🧠"
                    taskIcon = "🧠"
                    if (priority == "High Priority") {
                        taskIcon = "🧠 💎"
                    }
                } else if (category == "Physical") {
                    category = "Physical ❤️"
                    taskIcon = "❤️"
                    if (priority == "High Priority") {
                        taskIcon = "❤️ 💎"
                    }
                } else if (category == "Spiritual") {
                    category = "Spiritual 🙏"
                    taskIcon = "🙏"
                    if (priority == "High Priority") {
                        taskIcon = "🙏 💎"
                    }
                } else if (category == "General") {
                    category = "General 📝"
                    taskIcon = "📝"
                    if (priority == "High Priority") {
                        taskIcon = "📝 💎"
                    }
                }

                if (notesCopied == true) {
                    this.state.noteCopyBtnTxt = "Copied ✅"
                } else {
                    this.state.noteCopyBtnTxt = "Copy Existing Notes"
                }

                if (saveBtn == false) {
                    this.state.saveButtons = false
                } else {
                    this.state.saveButtons = true
                }

                if (saveTask == false) {
                    this.state.saveTaskTxt = "Save Task"
                } else {
                    this.state.saveTaskTxt = "Task Saved ✅"
                }

                if (saveNote == false) {
                    this.state.saveNoteTxt = "Save Note"
                } else {
                    this.state.saveNoteTxt = "Note Saved ✅"
                }

                if (bgColorCode == "#B8B8B8") {
                    greySetting = "Undo"
                } else {
                    greySetting = "Grey"
                }

                if (completed == false && greySetting == "") {
                    this.state.taskComplete = ""
                    bgColorCode = "#F5DE89"
                    completeTaskBtn = "Task Complete"
                } else if (completed == true && greySetting == "") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    bgColorCode = "#99CC63"
                    completeTaskBtn = "Successfully Completed ✅"
                } else if (completed == true && greySetting == "Grey") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    bgColorCode = "#99CC63"
                    completeTaskBtn = "Successfully Completed ✅"
                } else if (completed == false && greySetting == "Grey") {
                    this.state.taskComplete = ""
                    bgColorCode = "#F5DE89"
                    completeTaskBtn = "Task Complete"
                } else if (completed == false && greySetting == "Undo") {
                    this.state.taskComplete = ""
                    completeTaskBtn = "Task Complete"
                } else if (completed == true && greySetting == "Undo") {
                    this.state.taskComplete = "✅"
                    taskIcon = `${taskIcon} ✅ 🎉 `
                    completeTaskBtn = "Successfully Completed ✅"
                }


                if (minimizeStatus == true) {
                    this.state.taskButtons = true
                    this.state.minimizeTxt = "Minimize"
                }  else {
                    this.state.taskButtons = false
                    this.state.minimizeTxt = "Maximize"
                }


                if (examples == true) {
                    this.state.showAddExamples = true
                    this.state.exampleTxt = "Hide Notes"
                } else {
                    this.state.showAddExamples = false
                    this.state.exampleTxt = "Show Notes"
                }

                if (exampleInput == true) {
                    this.state.writeExample = true
                } else {
                    this.state.writeExample = false
                    // this.state.showIncompleteBtn = true
                }

                if (deleting == false) {
                    this.state.showIncompleteBtn = true
                    this.state.confirmDelete = false
                } else {
                    this.state.showIncompleteBtn = false
                    this.state.confirmDelete = true
                }

                if (completeBtns == false) {
                    this.state.showIncompleteBtn = false
                } else {
                    this.state.showIncompleteBtn = true
                }

                if (difficulty == "Manageable") {
                    difficulty = "👍"
                } else if (difficulty == "Challenging") {
                    difficulty = "🧨"
                } else if (difficulty == "Hard") {
                    difficulty = "🧨🧨"
                } else if (difficulty == "Very Hard") {
                    difficulty = "🧨🧨🧨"
                } else if (difficulty == "Super Hard") {
                    difficulty = "💣"
                }

                let taskStyle = {
                    backgroundColor: bgColorCode
                }

                let taskTxtColor = {
                    color: txtColorCode,
                    fontFamily: "DM Sans"
                }

                let taskCompleteLabel = {
                    marginLeft: "2%"
                }

                let completeBtnStyle = {
                    backgroundColor: this.state.taskCompleteBgColor,
                    color: this.state.taskCompleteTxtColor
                }

                let difficultyLabel = {
                    marginRight: "2%",
                    color: txtColorCode
                }

                let categoryContainer = {
                    textAlign: "left",
                    marginRight: "50%",
                }

                let categoryBtn = {
                    color: txtColorCode,
                    borderRadius: "5px",
                    backgroundColor: "transparent",
                    padding: "3%",
                    border: `0px solid ${txtColorCode}`,
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    marginBottom: "5.5%"
                }

                // const { width, height } = useWindowSize()

                return(
                    <Styles>
                        <div style={taskStyle} className='allTasks'>
                            <div className='taskInfo'>
                                <div className='hideItems'>
                                    <button
                                    onClick={() => this.minimizeTaskCard(id, minimizeStatus)}
                                    ><label style={taskTxtColor}>{this.state.minimizeTxt}</label></button>
                                    <button
                                    onClick={() => this.turnTaskGrey(id, bgColorCode, completed)}
                                    ><label style={taskTxtColor}>{greySetting}</label></button>
                                    <button
                                    onClick={() => this.saveBtnClicked(id, saveBtn)}
                                    ><label style={taskTxtColor}>Save</label></button>
                                </div>
                                <div className='taskLabel'>
                                    <h5 style={taskTxtColor} ><b>task - <label>{taskIcon}</label></b></h5>
                                </div>
                                <div className='taskData'>
                                    <div className="taskDataChild">
                                        <p>{task}
                                        <label style={taskCompleteLabel}>{this.state.taskComplete}</label></p>
                                    </div>
                                    {exampleList && 
                                        <div className="taskDataChild2">
                                            <p style={taskTxtColor}>Notes</p>
                                            <textarea
                                            value={notes}
                                            readOnly/>
                                        </div>
                                    }
                                </div>
                                {this.state.maximizeDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.maximizeDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                            <h4>You can add additional notes to tasks as you work on them</h4>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/maximizeDemo1.mp4" type="video/mp4"/>
                                            </video>     
                            
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.greyDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.greyDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                        <h4>You can move tasks to the background by 'greying' them, to focus on tasks at hand</h4>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/greyDemo1.mp4" type="video/mp4"/>
                                            </video>     
                            
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.saveDemo &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.saveDemoSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="maximizeDialogBox">
                                        <h4>You can also save tasks you want to re-add to your list later, as well as save notes that you make throughout the day</h4>
                                            <p>See how to do this below 👀</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/saveDemo1.mp4" type="video/mp4"/>
                                            </video>
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                {this.state.taskButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button style={categoryBtn}>
                                                Difficulty: {difficulty}
                                            </button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{category}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  style={categoryBtn}>{priority} 💎</button>
                                        </div>
                                        {this.state.showAddExampleBtn && 
                                            <div style={categoryContainer} className='taskCategory'>
                                                <button  
                                                onClick={() => this.addingExamples(id, examples)}
                                                style={categoryBtn}>{this.state.exampleTxt}</button>
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.saveButtons && 
                                    <div className='taskDifficulty'>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveTaskClicked(id, 
                                            saveTask, task, category, difficulty, 
                                            priority)}
                                            style={categoryBtn}
                                            >{this.state.saveTaskTxt}</button>
                                        </div>
                                        <div style={categoryContainer} className='taskCategory'>
                                            <button  
                                            onClick={() => this.saveNoteClicked(id, saveNote, notes)}
                                            style={categoryBtn}
                                            >{this.state.saveNoteTxt}</button>
                                        </div>
                                    </div>
                                }  
                            </div>
                            <div className='markComplete'>
                                <ShowMoreText
                                /* Default options */
                                lines={1}
                                more="Mark as Complete"
                                less="Hide"
                                className="content-css"
                                anchorClass="my-anchor-css-class"
                                // onClick={this.executeOnClick}
                                expanded={false}
                                width={10}
                                truncatedEndingComponent={""}
                                >
                                {this.state.showIncompleteBtn && 
                                    <div className="taskBtnAction">
                                        {this.state.showAddExamples && 
                                            <div>
                                                <button
                                                onClick={() => this.addExampleClicked(id, exampleInput)}
                                                style={completeBtnStyle}
                                                >Add Notes</button>
                                            </div>
                                        }
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.taskComplete(id, completed)}
                                        >{completeTaskBtn}</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.goToDeleteTask(id)}
                                        >Delete ❌</button>
                                    </div>
                                }
                                {this.state.confirmDelete && 
                                    <div className="taskBtnAction">
                                        <p style={taskTxtColor}>Are you sure you want to delete this task?</p>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.deleteTask(id)}
                                        >Yes ✅</button> <br/>
                                        <button
                                        style={completeBtnStyle}
                                        onClick={() => this.cancelDelete(id)}
                                        >No ❌</button>
                                    </div>
                                }
                                {this.state.writeExample && 
                                    <div className="taskBtnAction2">
                                        <div>
                                            <div className='noteCopyBtn'>
                                                <button
                                                onClick={() => this.copyingNotes(id, notes, notesCopied)}
                                                >{this.state.noteCopyBtnTxt}</button>
                                            </div>
                                            <p style={taskTxtColor}>{exampleErrMsg}</p>
                                            <textarea
                                            rows="3"
                                            placeholder="Enter your notes here"
                                            id="userExampleInput"
                                            value={this.state.userExampleInput}
                                            onChange={this.handleChange}
                                            />
                                            <br/>
                                            <button
                                            onClick={() => this.submitExample(id, this.state.userExampleInput)}
                                            style={completeBtnStyle}
                                            >Update</button>
                                            <br/>
                                            <button
                                            onClick={() => this.cancelExampleInput(id)}
                                            style={completeBtnStyle}
                                            >Close</button>
                                        </div>
                                    </div>
                                }
                                {/* <p>{completed}</p> */}
                                </ShowMoreText>
                                <h4>*space*</h4>
                            </div>
                        </div>
                    </Styles>
                )
            })
        } 
    }


    render () {

        let difficultyMsg = {
            color: "#724E39"
        }

            // DIFFICULTY BTNS

        let manageableBtn = {
            backgroundColor: this.state.manageableBgColor,
            color: this.state.manageableTxtColor
        }

        let kindaHardBtn = {
            backgroundColor: this.state.kindaHardBgColor,
            color: this.state.kindaHardTxtColor
        }

        let hardBtn = {
            backgroundColor: this.state.hardBgColor,
            color: this.state.hardTxtColor

        }

        let veryHardBtn = {
            backgroundColor: this.state.veryHardBgColor,
            color: this.state.veryHardTxtColor
        }

        let superHardBtn = {
            backgroundColor: this.state.superHardBgColor,
            color: this.state.superHardTxtColor
        }

            // CATEGORY BTNS

        let relationshipBtn = {
            backgroundColor: this.state.relationshipBgColor,
            color: this.state.relationshipTxtColor
        }

        let mentalBtn = {
            backgroundColor: this.state.mentalBgColor,
            color: this.state.mentalTxtColor
        }

        let physicalBtn = {
            backgroundColor: this.state.physicalBgColor,
            color: this.state.physicalTxtColor
        }

        let spiritualBtn = {
            backgroundColor: this.state.spiritualBgColor,
            color: this.state.spiritualTxtColor
        }

        let regTodoBtn = {
            backgroundColor: this.state.regTodoBgColor,
            color: this.state.regTodoTxtColor
        }

            // PRIORITY BTNS

        let lowPriorityBtn = {
            backgroundColor: this.state.lowPriorityBgColor,
            color: this.state.lowPriorityTxtColor
        }

        let highPriorityBtn = {
            backgroundColor: this.state.highPriorityBgColor,
            color: this.state.highPriorityTxtColor
        }

        return(
            <Styles>
                <Navbar expand="lg" className="theNavbar">
                    <Navbar.Brand className='logo' href="/home">Salis</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="navLinks ms-auto">
                        <Nav.Link className="linkItem" href="/saves" ><label><strong>Saves</strong></label></Nav.Link>
                        {/* <Nav.Link className="linkItem" href="/reads" ><label><strong>Reads</strong></label></Nav.Link> */}
                        <Nav.Link className="linkItem" onClick={this.logOut} href="/" ><label><strong>Logout</strong></label></Nav.Link>
                        {/* <Nav.Link className="linkItem" href="/login" ><label>Login</label></Nav.Link> */}
                    </Nav>
                    </Navbar.Collapse>
                </Navbar>
                
                {this.state.homePage && 
                    <div>
                        {this.state.newUser &&
                            <div>
                                <ReactDialogBox
                                className="modalDialogBox"
                                closeBox={this.introTutorialSeen}
                                modalWidth='80%'
                                headerBackgroundColor='#99CC63'
                                headerTextColor='#FFCC59'
                                headerFont='DM Sans'
                                headerHeight='40'
                                closeButtonColor='white'
                                bodyBackgroundColor='white'
                                bodyTextColor='black'
                                bodyHeight='100%'
                                headerText=""
                                >
                                <div className="dialogueBox">
                                    <img src="assets/addItemDemo.gif"/>
                                    <h4>Start here!</h4>
                                </div>
                                </ReactDialogBox>
                            </div>
                        }
                        <div className='header'>
                            <h1>{this.state.homeTxt}</h1>
                        </div>
                        {this.state.getStartedPg && 
                            <div className='getStartedPg'>
                                <button
                                onClick={this.getStartedClicked}
                                >Get Started</button>
                            </div>
                        }
                        <div className='mainPg'>
                            {/* <div className='mainPgCol1'>
                                <h4>Weekly </h4>
                            </div> */}
                            <div className='mainPgCol2'>
                                {this.state.homeList && 
                                <div className='theList'>
                                    {this.state.homeTopButtons && 
                                    <div className='homeTopButtons'>
                                        <div className='homeTopBtn'>
                                            <button
                                            onClick={this.goToItemAdd}
                                            >Add New Task</button>
                                        </div>
                                        <div className='homeTopBtn'>
                                            <button
                                            onClick={this.goToDailyReport}
                                            >Daily Report</button>
                                        </div>
                                    </div>
                                    }
                                    {this.state.showTaskTrailBtn &&
                                        <div className='taskTrailBtn'>
                                        <button
                                        onClick={this.goToTaskTrail}
                                        >{this.state.taskTrailBtn}</button>
                                    </div>
                                    }
                                    {this.state.showGoSlowBtn && 
                                        <div className='taskTrailBtn'>
                                            <button
                                            onClick={this.goToSlowMode}
                                            >{this.state.slowModeBtn}</button>
                                        </div>
                                    }
                                    {this.state.allTasks && 
                                        <div>
                                            {/* <h3>High Priority Tasks</h3> */}
                                            {this.renderHPTasks()}
                                            {/* <h3>All Other Tasks</h3> */}
                                            {this.renderLPTasks()}
                                        </div>
                                    }
                                    {this.state.taskTrailTasks && 
                                        <div>
                                            <TaskTrail
                                            userEmail = {this.state.userEmail}
                                            highPriorityBucket = {this.state.highPriorityTasks}
                                            lowPriorityBucket = {this.state.lowPriorityTasks}
                                            />
                                        </div>
                                    }
                                    {this.state.goSlowMode && 
                                        <div className='theList'>
                                            <div className='slowModeBtn'>
                                                <button
                                                onClick={this.shuffleTasks}
                                                >Show Me Another Task</button>
                                                <h4>Just do one task at a time 👍</h4>
                                            </div>
                                            {this.renderSlowTasks()}
                                        </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                        {this.state.addingItem && 
                            <div className='itemAddContainer'>
                                {this.state.newTask &&
                                    <div>
                                        <ReactDialogBox
                                        className="modalDialogBox"
                                        closeBox={this.newTaskTutorialSeen}
                                        modalWidth='80%'
                                        headerBackgroundColor='#99CC63'
                                        headerTextColor='#FFCC59'
                                        headerFont='DM Sans'
                                        headerHeight='40'
                                        closeButtonColor='white'
                                        bodyBackgroundColor='white'
                                        bodyTextColor='black'
                                        bodyHeight='100%'
                                        headerText=""
                                        overflow-y= "scroll"
                                        >
                                        <div className="newTaskDialogBox">
                                            <button
                                            onClick={this.newTaskTutorialSeen}
                                            >Close
                                            </button>
                                            <h4><u>1. Write out a task you want to get done today</u></h4>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/addTaskDemo1.mp4" type="video/mp4"/>
                                            </video>     

                                            <h4><u>2. Select a difficulty level</u></h4>
                                            <p>(This is based on how difficult you anticipate the task will be - or how difficult it has been for you to do this task recently)</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/addTaskDemo2.mp4" type="video/mp4"/>
                                            </video>      

                                            <h4><u>3. Select a category for this task</u></h4>
                                            <p></p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/addTaskDemo3.mp4" type="video/mp4"/>
                                            </video>    

                                            <h4><u>4. Select a priority level for this task</u></h4>
                                            <p>(If you're unsure about the priority of a task at first, don't worry too much about it - just select what feels right and you'll get better at determining this more clearly over time)</p>
                                            <video autoPlay muted loop playsInline>
                                                <source src="/assets/addTaskDemo4.mp4" type="video/mp4"/>
                                            </video>                                 
                                        </div>
                                        </ReactDialogBox>
                                    </div>
                                }
                                <h4>What Do You Want To Today?</h4>
                                <div className='addContainer'>
                                    <div className='addLabel'>
                                        <h5>Task</h5>
                                    </div>
                                    <div className='addInput'>
                                        <input
                                        id="task"
                                        value={this.state.task}
                                        onChange={this.handleChange}
                                        />
                                    </div>
                                </div>
                                <p>{this.state.taskErrMsg}</p>
                                <div className='addContainer'>
                                    <div className='addLabel'>
                                        <h5>Difficulty</h5>
                                    </div>
                                    <div className='addInput'>
                                        <div className='difficultyBtnFirst'>
                                            <button
                                            onClick={this.manageableClicked}
                                            style={manageableBtn}
                                            >Not Bad 👍</button>
                                        </div>
                                        <div className='difficultyBtn'>
                                            <button
                                            onClick={this.kindaHardClicked}
                                            style={kindaHardBtn}
                                            >Kinda Hard 🧨</button>
                                        </div>
                                        <div className='difficultyBtn'>
                                            <button
                                            onClick={this.hardClicked}
                                            style={hardBtn}
                                            >Hard 🧨🧨</button>
                                        </div>
                                        <div className='difficultyBtn'>
                                            <button
                                            onClick={this.veryHardClicked}
                                            style={veryHardBtn}
                                            >Very Hard 🧨🧨🧨</button>
                                        </div>
                                        <div className='difficultyBtnLast'>
                                            <button
                                            onClick={this.superHardClicked}
                                            style={superHardBtn}
                                            >Super Hard 💣</button>
                                        </div>
                                    </div>
                                </div>
                                <p style={difficultyMsg}>{this.state.difficultyErrMsg}</p>
                                <div className='addContainer'>
                                    <div className='addLabel'>
                                        <h5>Category</h5>
                                    </div>
                                    <div className='addInput'>
                                        <div className='categoryBtnFirst'>
                                            <button
                                            onClick={this.relationshipClicked}
                                            style={relationshipBtn}
                                            >R/ships 🤝</button>
                                        </div>
                                        <div className='categoryBtn'>
                                            <button
                                            onClick={this.mentalClicked}
                                            style={mentalBtn}
                                            >Mental 🧠</button>
                                        </div>
                                        <div className='categoryBtn'>
                                            <button
                                            onClick={this.physicalClicked}
                                            style={physicalBtn}
                                            >Physical ❤️</button>
                                        </div>
                                        <div className='categoryBtn'>
                                            <button
                                            onClick={this.spiritualClicked}
                                            style={spiritualBtn}
                                            >Spiritual 🙏</button>
                                        </div>
                                        <div className='categoryBtnLast'>
                                            <button
                                            onClick={this.generalClicked}
                                            style={regTodoBtn}
                                            >General Task 📝</button>
                                        </div>
                                    </div>
                                </div>
                                <p>{this.state.categoryErrMsg}</p>
                                <div className='addContainer'>
                                    <div className='addLabel'>
                                        <h5>Priority</h5>
                                    </div>
                                    <div className='addInput'>
                                        <div className='priorityBtnFirst'>
                                            <button
                                            onClick={this.lowPriorityClicked}
                                            style={lowPriorityBtn}
                                            >Not High Priority</button>
                                        </div>
                                        <div className='priorityBtnLast'>
                                            <button
                                            onClick={this.highPriorityClicked}
                                            style={highPriorityBtn}
                                            >High Priority</button>
                                        </div>
                                    </div>
                                </div>
                                <p>{this.state.priorityErrMsg}</p>
                                <div className='lastAddBtn'>
                                    <button
                                    onClick={this.submitTask}
                                    >Add Task</button>
                                    <br/>
                                    <button
                                    onClick={this.cancelAdd}
                                    >Back To Tasks</button>
                                </div>
                            </div>
                        }
                        {this.state.itemAddedSuccessfully && 
                            <div className='successfulAdd'>
                                <h2>Your task has been added successfully!</h2>
                                <br/>
                                <button
                                onClick={this.backToList}
                                >Back to List</button>
                                <br/>
                                <button
                                onClick={this.addAnotherTask}
                                >Add Another Task</button>
                            </div>
                        }
                    </div>
                } 
                {this.state.dailyReport && 
                    <div>
                        <DailyReport
                        highPriorityBucket = {this.state.highPriorityTasks}
                        lowPriorityBucket = {this.state.lowPriorityTasks}
                        />
                    </div>
                }
            </Styles>
        )
    }
}